export class User {
  /*
   * Check if user is authorised to use the service
   * 
   * (Also currently creates a user record on first login, and updates details
   * like name/profile image etc. whenever it's called)
   */
  public static authorise (
    email: string,
    imgUrl: string,
    name: string,
    done: (response: any) => void) : void
  {
    window.fetch((window as any).API_LOCATION+"/user/authorise", {
      body: JSON.stringify({
        /* security hole - use a verified ID token stored as a cookie */
        "email": email,
        "imgUrl": imgUrl,
        "name": name,
      }),
      cache: "no-cache",
      credentials: 'include',
      headers: {
        "Content-Type": "application/json; charset=utf-8"
      },
      method: "POST",
      mode: "cors",
      redirect: "error",
      referrer: "no-referrer"
    })
    .then(response => response.json())
    .then(json => { done(json) })
    .catch((error) => {
      console.log(error);
      console.log("User.authorise::catch() called, something went wrong");
    })
    ;
  }
}



// WEBPACK FOOTER //
// ./src/Api/User.ts